import React from 'react';
import { ComplementaryColor } from '@lux/tokens';
import { Banner } from '../banner';
import { useEducationalMessage } from '../../useEducationalMessage';
const noop = () => { };
export const EducationalMessage = ({ cookieName, icon, title, text, onLinkClick, linkText, isPlatformJourneyEnabled, descriptionTextTop, descriptionTextBottom, onDismiss = noop, onVisible = noop, }) => {
    const { isVisible, hideEducationalMessage } = useEducationalMessage({
        uniqueHideCookieName: cookieName,
        isPlatformJourneyEnabled,
    });
    if (!isVisible) {
        return null;
    }
    const onCloseBanner = () => {
        hideEducationalMessage();
        onDismiss();
    };
    return (React.createElement(Banner, { icon: icon, title: title, text: text, onCloseBanner: onCloseBanner, linkText: linkText, onLinkClick: onLinkClick, color: ComplementaryColor.brand30, descriptionTextTop: descriptionTextTop, descriptionTextBottom: descriptionTextBottom, onVisible: onVisible }));
};
//# sourceMappingURL=component.js.map